import { Mask } from 'maska';

export function formatPhoneNumber(phone: string): string {
  return new Mask({ mask: '+1 (###) ###-####' }).masked(phone);
}
